module.exports = __webpack_public_path__ + "img/infiniti-New.9e2fb66d.png";